import PropTypes from 'prop-types'
import React from 'react'
import { Controller, useForm, FormProvider } from 'react-hook-form'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

import Thanking from '../thanking'
import Spinner from '../../inline/spinner.svg'
import FileInput from '../inputFile'
import { useOffers } from '../offersContext'
import ChoiceList from './choice-list'
import OpenQuestion from './open-question'
import useRecruiteeForm from './use-recruitee-form'

export const civilityOptions = [
  {
    label: 'Mr',
    value: 'MR',
  },
  {
    label: 'Ms',
    value: 'MS',
  },
]

export default function Application({ offer }) {
  const methods = useForm()

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { isSubmitting, errors },
  } = methods

  const { isSuccess, error, onSubmit } = useRecruiteeForm({ offer, reset })

  const { setTab } = useOffers()

  const backToOffer = () => setTab('content')

  if (isSuccess) return <Thanking backToOffer={backToOffer} />

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className='mt-2'
        encType='multipart/form-data'
      >
        {error && (
          <p
            className='form-animation__message invalid form-animation__error'
            style={{ color: 'red' }}
          >
            {error}
          </p>
        )}
        <div className='grid-x grid-margin-x mb-1'>
          <div className='cell medium-12'>
            <ChoiceList
              options={civilityOptions}
              name='civility'
              hasError={!!errors.civility}
              required
            />
          </div>

          <div className='cell medium-6'>
            <label className='input-block contact-form__block mb-24 cell'>
              <span className='contact-form__label mb-8'>First name *</span>
              <input
                className={`input-field contact-form__input ${errors[
                  'firstName'
                ] && 'checkbox__input_err'}`}
                type='text'
                {...register('firstName', {
                  required: true,
                })}
              />
            </label>
          </div>

          <div className='cell medium-6'>
            <label className='input-block contact-form__block mb-24 cell'>
              <span className='contact-form__label mb-8'>Last name *</span>
              <input
                className={`input-field contact-form__input ${errors[
                  'lastName'
                ] && 'checkbox__input_err'}`}
                type='text'
                {...register('lastName', {
                  required: true,
                })}
              />
            </label>
          </div>

          <div className='cell medium-6'>
            <label className='input-block contact-form__block mb-24 cell'>
              <span className='contact-form__label mb-8'>Email *</span>
              <input
                className={`input-field contact-form__input 
                ${errors?.candidate?.email && 'checkbox__input_err'}`}
                type='email'
                {...register('candidate[email]', {
                  required: true,
                })}
              />
            </label>
          </div>

          <div className='cell medium-6'>
            <label className='input-block contact-form__block mb-24 cell'>
              <span className='contact-form__label mb-8'>Phone number *</span>

              <Controller
                {...register('candidate[phone]', {
                  required: true,
                })}
                name='candidate[phone]'
                control={control}
                render={({ field }) => (
                  <>
                    <PhoneInput
                      buttonStyle={{
                        background: '#36383d',
                        border: errors?.candidate?.phone
                          ? '1px solid red'
                          : '1px solid #6f7075',
                      }}
                      dropdownStyle={{
                        background: '#323438',
                      }}
                      inputStyle={{
                        height: '56px',
                        width: '100%',
                        borderColor: errors?.candidate?.phone
                          ? 'red'
                          : '#E6E8EC60',
                        background: 'transparent',
                      }}
                      country={'ch'}
                      {...field}
                    />
                  </>
                )}
              />
            </label>
          </div>
        </div>

        {offer.open_questions.length > 0 && (
          <div className='mb-1' id='application_questions'>
            <div className='mt-1'>
              <h3>Questions *</h3>
            </div>

            {offer.open_questions.map(question => (
              <OpenQuestion
                key={question.id}
                hasError={errors?.questions?.[question.id]}
                {...question}
              />
            ))}
          </div>
        )}

        <FileInput
          errors={errors.cv}
          accept='application/pdf'
          label='Upload your resume *'
          {...register('cv', {
            required: true,
          })}
        />

        <button
          type='submit'
          className='contact-form__button'
          disabled={isSubmitting}
        >
          {!isSubmitting ? (
            <span>Send</span>
          ) : (
            <img
              className='loader'
              height={40}
              width={40}
              src={Spinner}
              alt=''
            />
          )}
        </button>
      </form>
    </FormProvider>
  )
}

Application.propTypes = {
  offer: PropTypes.object.isRequired,
}
